import React, { useEffect, useRef, useState } from "react";
import { Avatar, Box, Divider, Grid2, List, ListItem, ListItemAvatar, ListItemIcon, ListItemText, MenuItem, Select, styled, Tab, Tabs, Typography, useTheme } from "@mui/material";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useGetEngineeringProgressCurveQuery } from "store/slices/apis/engineeringDashboardSlice";
import { useGetConstructionProgressCurveQuery } from "store/slices/apis/constructionDashboardSlice ";
import { useGetProcurementProgressCurveQuery } from "store/slices/apis/procurementDashboardSlice";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { Skeleton } from '@mui/material';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import moment from "moment";
// dayjs.extend(isSameOrBefore);

const StyledTab = styled(Tab)(({ theme }) => ({
    textTransform: "none", // Prevent uppercase
    fontWeight: "400",
    fontSize: "14px",
    color: "#37352F",
    padding: '0px',
    minHeight: '0px',
    minWidth: '0px',
    margin: '20px 20px 5px 5px',
    "&.Mui-selected": {
        color: `${theme?.customSettings?.themeColor}`,
    }
}));

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

const EPCCompletion = () => {

    const [tabIndex, setTabIndex] = useState(0);
    const theme = useTheme();

    const { projectId } = useParams();
    const { data: engineeringData, isLoading } = useGetEngineeringProgressCurveQuery({ projectId });
    const { data: constructionData } = useGetConstructionProgressCurveQuery({ projectId });
    const { data: procurementData } = useGetProcurementProgressCurveQuery({ projectId });

    const getFinalData = () => {
        //if (tabIndex === 0 && Array.isArray(engineeringData)) return engineeringData.slice(0, 6);
        if (tabIndex === 0 && Array.isArray(engineeringData)) return engineeringData;
        if (tabIndex === 1 && Array.isArray(procurementData)) return procurementData;
        if (tabIndex === 2 && Array.isArray(constructionData)) return constructionData;
        return [];
    };

    const finalData = getFinalData();

    // const filteredData = finalData.filter(item => dayjs(item.month, 'MMM-YYYY').isSameOrBefore(dayjs(), 'month'));

    const filteredData = finalData.filter(item => moment(item.month, "MMM-YYYY").isSameOrBefore(moment(), "month"));

    const handleChange = (_, newValue) => {
        setTabIndex(newValue);
    };
    const options = {
        chart: {
            type: 'column',
            height: 300,
        },
        title: {
            text: null,
        },
        xAxis: {
            categories: filteredData?.map(item =>
                moment(item.month, 'MMM-YYYY').format('MMM,YY')
            ),
            title: {
                text: "Months",
            },
            crosshair: true,
            labels: {
                style: {
                    fontSize: '12px',
                }
            }
        },
        yAxis: {
            min: 0,
            max: 100,
            title: {
                text: "Progress Percentage",
            },
            labels: {
                format: '{value}%',
            },
        },
        plotOptions: {
            column: {
                borderRadius: 4,
                pointPadding: 0.2,
                borderWidth: 0,
            }
        },
        series: [
            {
                name: 'Actual',
                color: '#E72B33',
                data: filteredData?.map(item => ({
                    y: item.actual ?? 0,
                })),
            },
            {
                name: 'Plan',
                color: '#295477',
                data: filteredData?.map(item => ({
                    y: item.plan ?? 0,
                })),
            }
        ],
        credits: {
            enabled: false,
        },
        legend: {
            enabled: true,
            layout: 'horizontal',
            align: 'left',
            verticalAlign: 'top',
            itemStyle: {
                fontSize: '15px',
            },
            symbolRadius: 0,
            symbolHeight: 13,
            symbolWidth: 13,
            itemMarginBottom: 20,
            margin: 20,
        },
    };
    return (
        <Box sx={{ padding: 2, border: '1px solid #2525252E', borderRadius: '7px', background: "#FFFFFF", minHeight: "470px", width: "100%", overflowX: "auto" }}>
            <Grid2 container>
                <Grid2 size={{ xs: 12, md: 12 }}>
                    <Typography variant="h6" sx={{ fontWeight: "500", fontSize: '18px', color: `#182A4E`, lineHeight: '100%', letterSpacing: '-0.4px' }}>
                        EPC Completion
                    </Typography>
                    <Typography variant="caption" sx={{ fontWeight: "500", fontSize: '16px', color: `#182A4E80`, lineHeight: '100%', letterSpacing: '-0.4px' }}>
                        Completion % in each phase of the project
                    </Typography>
                    <Grid2 container spacing={1}>
                        <Grid2 size={12}>
                            <Box sx={{ borderBottom: 0, borderColor: 'divider' }}>
                                <Tabs value={tabIndex} onChange={handleChange} sx={{
                                    minHeight: "0px",
                                    "& .MuiTabs-indicator": { backgroundColor: `${theme?.customSettings?.themeColor}` },
                                }}>
                                    <StyledTab label="Engineering" sx={{ textTransform: 'none' }} />
                                    <StyledTab label="Procurement" sx={{ textTransform: 'none' }} />
                                    <StyledTab label="Construction" sx={{ textTransform: 'none' }} />
                                </Tabs>

                                {[0, 1, 2].map((index) => (
                                    <CustomTabPanel value={tabIndex} index={index}>
                                        {isLoading ? (
                                            <Skeleton variant="rectangular" width="100%" height={300} animation="wave" />
                                        ) : (
                                            <HighchartsReact highcharts={Highcharts} options={options} />
                                        )}
                                    </CustomTabPanel>
                                ))}

                            </Box>
                        </Grid2>
                    </Grid2>
                </Grid2>
            </Grid2>
        </Box >
    );
};

export default EPCCompletion;
